<template>
  <div class="home">
    <ComponentHeader v-bind:index="index" v-on:setHeight="getHeight" />

    <header class="lunbo">
      <!-- 蒙版 -->
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div></div>
        </el-col>
      </el-row>
      <!-- 轮播 -->
      <el-row class="lunbo">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-carousel
            id="el-carousel__container"
            :height="bannerHeight"
            :interval="4000"
          >
            <el-carousel-item>
              <h3>
                <img src="../assets/image/1-01-01.png" />
                <div class="txt">
                  <div class="txt_f">诚信,优质,团结,敬业</div>
                  <div class="txt_z">峰润洗涤</div>
                </div>
              </h3>
            </el-carousel-item>
          </el-carousel>
        </el-col>
      </el-row>
    </header>

    <section>
      <el-row class="block">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="block_title"
          >企业简介</el-col
        >
        <el-row class="qyjj">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="lunbo">
            <el-carousel id="qyjj" :height="bannerHeight2" :interval="400000">
              <el-carousel-item class="qyjy_lubo_01">
                <div></div>
              </el-carousel-item>
              <el-carousel-item class="qyjy_lubo_02">
                <div></div>
              </el-carousel-item>
              <el-carousel-item class="qyjy_lubo_03">
                <div></div>
              </el-carousel-item>
            </el-carousel>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="content">
            <div class="txt">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;泰州市峰润洗涤服务有限公司以规范、专业创新、共赢的经营理念，高效贴心的服务，团结协作、敬业负责、服务奉献、求实进取的企业精神，始终贯彻以追求合作伙伴最大利益为目标，竭诚为合作伙伴提供最大程度的保障。
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司十分重视诚信及企业文化建设，秉承“诚信、优质、团结、敬业”的企业精神，恪守“以完美服务为核心，以洗涤质量求生存，以用户满意为准则”的服务宗旨，生产水平和质量管理走在行业前列。运行几年来，公司业务不断发展，目前承担了江苏省苏北人民医院租赁洗涤服务、常州市第一人民医院租赁洗涤服务、泰州市第二人民医院租赁洗涤服务、泰州市中医院洗涤服务、泰州市第四人民医院洗涤服务等工作，洗涤服务质量不断提升，得到服务单位多次表扬。
              </p>
            </div>
            <div class="moreBtn">
              <button @click="tabSelect('2')">查看更多</button>
            </div>
          </el-col>
        </el-row>
      </el-row>
      <!-- 工厂洗涤设备吊袋系统智能 -->
      <el-row class="znsb">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="block_title"
          >工厂洗涤设备吊袋系统智能</el-col
        >
        <el-row class="znsb_pic">
          <el-col
            :xs="12"
            :sm="12"
            :md="6"
            :lg="6"
            :xl="6"
            v-for="(item, index) of znsb"
            :key="index"
          >
            <div class="pic">
              <img :src="item.imgUrl" alt="" />
              <span>{{ item.mc }}</span>
            </div>
          </el-col>
        </el-row>
      </el-row>
      <!-- 新闻 -->
      <el-row class="news" v-if="this.total">
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="24"
          :xl="24"
          class="block_title new_bt"
          >最新资讯</el-col
        >
        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="news_block">
          <el-col
            class=""
            :xs="24"
            :sm="24"
            :md="24"
            :lg="24"
            :xl="24"
            v-for="(item, index) of news"
            :key="index"
          >
            <div class="new">
              <div class="head" @click="lookNew(item.GG_ID)">
                <div>{{ item.GG_BT }}</div>
                <div>{{ item.GG_CJSJ }}</div>
              </div>
              <ul></ul>
            </div>
          </el-col>
        </el-col>

        <el-pagination
          v-if="total !== 0"
          ref="page"
          id="page"
          layout="prev, pager, next"
          :total="total"
          :page-size="4"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </el-row>
      <!-- 主营业务 -->
      <el-row class="block subyw" :gutter="10">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="subyw_bt"
          >主营业务</el-col
        >
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="main">
            <div>
              <img src="../assets/image/main_pic1.jpg" alt="" />
              <div>医用织物洗涤</div>
            </div>
            <div>
              <img src="../assets/image/main_pic2.jpg" alt="" />
              <div>工服洗涤</div>
            </div>
          </el-col>
        </el-row>

        <div class="line"></div>

        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="block_tzbt"
          >拓展业务</el-col
        >
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="main">
            <div>
              <img src="../assets/image/tz_yw01.png" alt="" />
              <div>酒店布草洗涤</div>
              <div></div>
            </div>
            <div>
              <img src="../assets/image/tz_yw02.png" alt="" />
              <div>干洗</div>
            </div>
          </el-col>
        </el-row>
        <div :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="seeMore">
          <button @click="tabSelect('4')">查看更多</button>
        </div>
      </el-row>
    </section>
    <ComponentFooter />
  </div>
</template>

<script>
import "../ui/ui.js";
import { axios } from "../service/http";
import moment from "moment";
import ComponentFooter from "../components/Footer.vue";
import ComponentHeader from "../components/Header.vue";

export default {
  components: { ComponentFooter, ComponentHeader },
  name: "Home",
  computed: {},
  data() {
    return {
      index: "1",
      bannerHeight: "700px",
      bannerHeight2: "300px",
      news: [],
      total: 100,
      q: {
        ps: 4,
        pi: 1,
        txt: "",
        zt: "Y",
      },
      znsb: [
        { imgUrl: require("../assets/image/sb01.png"), mc: "隧道式洗衣龙" },
        { imgUrl: require("../assets/image/sb02.png"), mc: "四棍烫平机" },
        { imgUrl: require("../assets/image/sb03.png"), mc: "穿梭机" },
        { imgUrl: require("../assets/image/sb04.png"), mc: "贯穿式烘干机" },
        {
          imgUrl: require("../assets/image/sb05.png"),
          mc: "50公斤全自动洗脱机",
        },
        { imgUrl: require("../assets/image/sb06.png"), mc: "发电机组" },
        { imgUrl: require("../assets/image/sb07.png"), mc: "堆码机" },
        {
          imgUrl: require("../assets/image/sb08.png"),
          mc: "100公斤隔离式洗衣机",
        },
        { imgUrl: require("../assets/image/sb09.png"), mc: "离心脱水机" },
        { imgUrl: require("../assets/image/sb10.png"), mc: "100公斤烘干机" },
        { imgUrl: require("../assets/image/sb11.png"), mc: "吊袋" },
        { imgUrl: require("../assets/image/sb12.png"), mc: "高速折叠机" },
        { imgUrl: require("../assets/image/sb13.png"), mc: "压榨机" },
        { imgUrl: require("../assets/image/sb14.png"), mc: "锅炉房" },
        { imgUrl: require("../assets/image/sb15.png"), mc: "四工位展布机" },
        { imgUrl: require("../assets/image/sb16.png"), mc: "真空烫台" },
      ],
    };
  },
  methods: {
    lookNew(i) {
      this.$router.push(`/new/${i}`);
    },
    getNews() {
      axios.get("TZGG", { params: this.q }).then((res) => {
        res.response.data.forEach((item) => {
          item.GG_CJSJ = moment(item.GG_CJSJ).format("YYYY-MM-DD");
        });
        this.news = res.response.data;
        this.total = res.response.total;
      });
    },
    handleCurrentChange(i) {
      this.q.pi = i;
      this.getNews();
    },
    getHeight(Height) {
      if (Height[0]) {
        this.bannerHeight = Height[0];
      }
      if (Height[1]) {
        this.bannerHeight2 = Height[1];
      }
    },
    changePageColor() {
      document.querySelectorAll("#page>button")[0].style.background = "#B8BCD9";
      document.querySelectorAll("#page>button")[1].style.background = "#B8BCD9";
      let page = document.querySelectorAll("#page>ul>li.number");
      page.forEach((ele) => {
        ele.style.background = "#B8BCD9";
      });
    },
  },
  mounted() {
    this.getNews();
  },
};
</script>


<style lang="less" scoped>
.home {
  font-family: "Microsoft YaHei";
  .el-row {
    margin: 0 !important;
  }
  header.lunbo {
    .lunbo {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      .el-col {
        .el-carousel {
          .el-carousel__container {
            .el-carousel__item h3 {
              font-size: 14px;
              line-height: 200px;
              margin: 0;
              img {
                width: 100%;
                height: 100%;
              }
              .txt {
                position: absolute;
                top: 30%;
                left: 15%;
                display: flex;
                justify-content: flex-start;
                flex-direction: column;
                line-height: 1;
                color: #d2f9e9;
                text-align: left;
                font-weight: 400;
                .txt_f {
                  font-weight: 400;
                  font-size: 0.18rem;
                }
                .txt_z {
                  font-size: 0.15rem;
                  font-weight: 400;
                  margin: 0.3rem 0 0 0;
                }
              }
            }
            .el-carousel__item:nth-child(2n) {
              background-color: #99a9bf;
            }
            .el-carousel__item:nth-child(2n + 1) {
              background-color: #d3dce6;
            }
          }
        }
      }
    }
  }
  section {
    .block {
      display: flex;
      justify-content: center;
      flex-direction: column;
      .qyjj {
        margin: 0rem 0 0rem 0 !important;
      }
      .bt ();
      .content,
      .lunbo {
        font-size: 0.1rem;
        margin-bottom: 0.26rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        .el-carousel {
          width: 75%;
          .qyjy_lubo_01 {
            div {
              height: 100%;
              background: url("../assets/image/qyjj_01.png") no-repeat;
              background-size: 100% 100%;
            }
          }
          .qyjy_lubo_02 {
            div {
              height: 100%;
              background: url("../assets/image/qyjj_02.png") no-repeat;
              background-size: 100% 100%;
            }
          }
          .qyjy_lubo_03 {
            div {
              height: 100%;
              background: url("../assets/image/qyjj_03.png") no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
      .lunbo {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .content {
        height: 80%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        font-size: 0.08rem;
        font-weight: 400;
        .txt {
          width: 75%;
        }
        .moreBtn {
          margin: 36px 0 0 0;
          width: 85%;
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          button {
            outline: 0;
            border: 0;
            width: 84px;
            height: 33px;
            background: #e6fffb;
            color: rgb(76, 4, 4);
            border-radius: 30px;
          }
        }
      }
      .mainBus_Title {
        font-size: 0.13rem;
        margin: 0.15rem 0 0.15rem 0.5rem;
      }
    }
    .znsb {
      background: #d2eae8;
      .bt ();
      .block_title {
        margin-bottom: 0.15rem;
      }
      .img {
        width: 85%;
        display: flex;
        justify-content: flex-start;
      }
      .znsb_pic {
        width: 100%;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        div.pic {
          margin: 22px 0;
          display: flex;
          justify-content: center;
          // align-items: center;
          flex-direction: column;
          align-items: center;
          img {
            width: 1rem;
            height: 0.6rem;
          }
          span {
            margin: 10px 0;
            width: 1.2rem;
            display: block;
            font-size: 0.08rem;
            text-align: center;
          }
        }
      }
    }
    .news {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .new_bt {
        margin-bottom: 0.25rem;
      }
      .bt ();
      .news_block {
        margin-bottom: 0.25rem;
        .el-col {
          font-size: 26px;
          margin-bottom: 10px;
          div.new {
            width: 100%;
            // height: 75px;
            background: #fff;
            // opacity: 0.6;
            border-radius: 0.1rem;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            .head {
              height: 100%;
              padding: 10px;
              display: block;
              padding: 5px 5px 5px 10px;
              font-size: 0.08rem;
              display: flex;
              justify-content: space-between;
              div {
                &:first-child {
                  width: 70%;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                  overflow: hidden;
                }
                &:last-child {
                  width: 25%;
                  text-align: right;
                }
              }
            }
            ul {
              width: 100%;
              border-bottom: 1px dashed #707070;
            }
            .new_btn {
              display: block;
              text-align: center;
              margin-bottom: 20px;
              button {
                width: 0.8rem;
                height: 0.18rem;
                background: #f9f0ff;
                border-radius: 0.15rem;
                background: #f9f0ff;
                outline: 0;
                border: 0;
              }
            }
          }
        }
      }
      #page {
        display: flex;
        justify-content: center;
        height: 50px;
        width: 90%;
      }
    }
    .subyw {
      background: #d2eae8;
      .subyw_bt {
        margin: 0.22rem 0 0.2rem 0;
        font-size: 0.16rem;
        text-align: center;
        font-weight: bold;
        color: #1f948d;
      }
      .block_tzbt {
        margin: 0 0 0.2rem 0;
        font-size: 0.16rem;
        text-align: center;
        font-weight: bold;
        color: #1f948d;
      }
      .line {
        height: 1px;
        width: 80%;
        border-bottom: 1px dashed #707070;
        margin: 0.22rem auto;
      }
      .main {
        width: 100%;
        display: flex;
        justify-content: center;
        text-align: center;
        // font-size: 16px;
        font-size: 0.08rem;
        // font-weight: bold;
        div {
          width: 25%;
          &:first-child {
            margin: 0 0.5rem 0 0;
          }
          &:last-child {
            margin: 0 0px 0 0.5rem;
          }
          img {
            width: 100%;
            margin-bottom: 10px;
          }
          div {
            width: 100%;
            text-align: center;
            margin: 0 !important;
            margin-top: 15px;
            font-size: 0.1rem !important;
          }
        }
      }
      .seeMore {
        font-size: 0.7rem;
        font-weight: 400;
        display: flex;
        justify-content: center;
        margin: 25px 0 22px 0;
        button {
          width: 84px;
          height: 33px;
          background: #e6fffb;
          color: #000;
          border-radius: 30px;
          outline: 0;
          border: 0;
        }
      }
    }
  }
}

.bt {
  .block_title {
    margin-top: 0.22rem;
    margin-bottom: 0.2rem;
    font-weight: bold;
    color: #1f948d;
    font-size: 0.16rem;
    text-align: center;
  }
}
</style>